import { createSelector } from '@reduxjs/toolkit';
import { smoEnvironmentColors } from '../../../../Models/Smo/SmoEnvironmentColors';
import { WidgetDisplayMode } from '../../../../Models/Widget/WidgetDisplayMode';
import { DEFAULT_GAME_LANGUAGE } from '../../../../Utils/Constants';
import UserRunUtils from '../../../../Utils/UserRunUtils';
import { storeSelector } from '../../Global/StoreSelector';

const defaultColor: string = '#E60012';

const displayMode = createSelector(
  storeSelector,
  (state) => state.widget.settings?.displayMode ?? WidgetDisplayMode.all
);
const moonLanguage = createSelector(
  storeSelector,
  (state) => state.widget.settings?.moonLanguage ?? DEFAULT_GAME_LANGUAGE
);
const scale = createSelector(storeSelector, (state) => state.widget.settings?.scale ?? 0);
const run = createSelector(storeSelector, (state) => state.widget.run);
const collectedMoonsCount = createSelector(storeSelector, (state) => state.widget.run?.collectedMoons.length ?? 0);
const remainingMoonsCount = createSelector(storeSelector, (state) => state.widget.run?.moonList.moonCount ?? 0);
const nextMoon = createSelector(storeSelector, (state) => {
  if (!state.widget.run) {
    return undefined;
  }
  return UserRunUtils.nextMoon(state.widget.run);
});
const primaryColor = createSelector(
  storeSelector,
  (state) => smoEnvironmentColors[state.widget.environment]?.primary ?? defaultColor
);
const secondaryColor = createSelector(
  storeSelector,
  (state) => smoEnvironmentColors[state.widget.environment]?.secondary ?? defaultColor
);

export default {
  displayMode,
  moonLanguage,
  scale,
  run,
  collectedMoonsCount,
  remainingMoonsCount,
  nextMoon,
  primaryColor,
  secondaryColor
};
